module.exports = __webpack_public_path__ + "static/media/image-card-2.e4283a6e.png";